<template>
  <div class="container anuncio-container text-left pb-5">
    <div v-if="loadingGeral" class="p-5">Carregando...</div>
    <div v-if="!loadingGeral">
      <div class="row align-items-center mt-3">
        <div class="col-lg-8">
          <div class="mb-2">
            <router-link to="/dashboard/meus-anuncios" replace>&lt; Meus anúncios</router-link>
          </div>

          <div
            v-if="dadosForm.anuncio.idAnuncio && dadosForm.anuncio.status == statusAnuncio.STATUS_ANUNCIO_NAO_FINALIZADO"
          >
            <h2>Completar anúncio</h2>
            <p>Complete com as informações que ainda faltam e clique no botão salvar no final da página.</p>
          </div>
          <div v-else-if="dadosForm.anuncio.idAnuncio">
            <h2>Editar anúncio</h2>
            <p>Edite as informações e clique no botão salvar no final da página.</p>
          </div>
          <div v-else>
            <h2>Novo anúncio</h2>
            <h5>Para começar, vamos preencher alguns dados</h5>
          </div>
        </div>
        <div class="col-lg-4 text-center mb-3">
          <img src="/img/iconeNovoAnuncio.png" class="icone-novo-anuncio" />
        </div>
      </div>

      <ValidationObserver ref="formEtapas">
        <!-- v-slot="{ invalid }" -->
        <RevealStepForm :count="stepCount" :offsetY="-12" :openUntilStep="openUntilStep">
          <template v-slot:progress-indicator="{ currentStep }">
            <div class="div mt-3 text-muted">
              <!-- <small>Etapa {{currentStep+1}} de {{count}}</small> -->
              <small v-if="currentStep < 2"></small>
              <small v-else-if="currentStep < 3">Etapa 1 de 6</small>
              <small v-else-if="currentStep < 6">Etapa 2 de 6</small>
              <small v-else-if="currentStep < 7">Etapa 3 de 6</small>
              <small v-else-if="currentStep < 8">Etapa 4 de 6</small>
              <small v-else-if="currentStep < 9">Etapa 5 de 6</small>
              <small v-else-if="currentStep < 10">Etapa 6 de 6</small>
            </div>
          </template>
          <template v-slot:step0="{ openNextStep }">
            <b-card
              class="shadow mb-5"
              v-if="dadosForm.registrosDisponiveis.length > 0 && !dadosForm.anuncio.idAnuncio"
            >
              <label>Escolha qual das suas bicicletas deseja anunciar:</label>
              <div class="row small-gutters mt-3">
                <div
                  class="col-6 col-md-3 mb-3"
                  v-for="registro in dadosForm.registrosDisponiveis"
                  :key="registro.id"
                >
                  <button
                    class="btn btn-light btn-block text-left border shadow-sm h-100"
                    @click="onClickBikeExistente(openNextStep, registro)"
                  >
                    <div class="marca">{{registro.marca}}</div>
                    <div class="modelo">{{registro.modelo}}</div>
                    <div>
                      <small>
                        <i>{{registro.descricaoTipoBike}}</i>
                      </small>
                    </div>
                  </button>
                </div>
                <div class="col-6 col-md-3 mb-3">
                  <button
                    class="btn btn-light btn-block border shadow-sm h-100"
                    style="min-height:100px"
                    @click="onClickOutraBike(openNextStep)"
                  >
                    <span class="text-info">Anunciar uma outra bike</span>
                  </button>
                </div>
              </div>
            </b-card>
          </template>

          <template v-slot:step1="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-1">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <validation-provider
                    name="condição"
                    rules="required"
                    v-slot="{ errors, classes }"
                  >
                    <label>Qual a condição da blicicleta a ser anunciada ?</label>
                    <b-form-radio-group
                      id="radio-group-2"
                      v-model="dadosForm.anuncio.condicaoBike"
                      name="condicao-bike"
                      size="lg"
                      :class="classes"
                      @input="onChangeCondicaoBike"
                    >
                      <b-form-radio :value="config.CONDICAO_BIKE_NOVA" class="mr-5">Nova</b-form-radio>
                      <b-form-radio :value="config.CONDICAO_BIKE_USADA">Usada</b-form-radio>
                    </b-form-radio-group>
                    <span class="invalid-feedback">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="col-md-6">
                  <div class="form-group" v-if="exibirTempoUso">
                    <label>Quanto tempo de uso:</label>
                    <validation-provider
                      name="tempo de uso"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(tempoUsoBike)"
                        v-model="dadosForm.anuncio.tempoUsoMeses"
                        :class="classes"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="text-right" v-if="isNextStepClosed">
                <button
                  :disabled="loadingContinuarEtapa"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep, true)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>

          <template v-slot:step2="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-5">
              <h5 class="font-weight-bold">1. Informações gerais</h5>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Marca:</label>
                    <validation-provider name="marca" rules="required" v-slot="{ errors, classes }">
                      <VueSelectOtherOption
                        placeholder="Selecione..."
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.marcas)"
                        v-model="dadosForm.anuncio.marca"
                        otherOptionText="Informar outra marca"
                        otherOptionPlaceholder="Digite o nome da marca"
                        @otherOptionChanged="
                          (otherOption) => {
                            dadosForm.anuncio.outraMarca = otherOption;
                            forceOtherOptionModelo = otherOption;
                          }
                        "
                        @optionSelected="popularModelos"
                        :classes="classes"
                      ></VueSelectOtherOption>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Modelo:</label>

                    <validation-provider
                      name="modelo"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <VueSelectOtherOption
                        placeholder="Selecione..."
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.modelos)"
                        v-model="dadosForm.anuncio.modelo"
                        otherOptionText="Informar outro modelo"
                        otherOptionPlaceholder="Digite o nome do modelo"
                        @otherOptionChanged="
                          (otherOption) =>
                            (dadosForm.anuncio.outroModelo = otherOption)
                        "
                        :classes="classes"
                        :forceOtherOption="forceOtherOptionModelo"
                        :disabled="!dadosForm.anuncio.marca"
                      ></VueSelectOtherOption>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    <div v-if="loadingModelos">Carregando...</div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Modalidade:</label>
                    <validation-provider
                      name="modalidade"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.tiposBike)"
                        v-model="dadosForm.anuncio.idTipoBike"
                        :class="classes"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Recomendada para:</label>
                    <validation-provider
                      name="recomendada"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="
                          helper.getOptions(dadosForm.tiposRecomendacao)
                        "
                        v-model="dadosForm.anuncio.idTipoRecomendacao"
                        :class="classes"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Cor predominante:</label>
                    <validation-provider name="cor" rules="required" v-slot="{ errors, classes }">
                      <b-form-input type="text" v-model="dadosForm.anuncio.cor" :class="classes"></b-form-input>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                    <!-- <div class="text-muted">
                <small>Se tiver mais de uma cor, informe a cor predominante.</small>
                    </div>-->
                  </div>
                </div>
                 <div class="col-lg-6">
                  <div class="form-group">
                    <label>Ano:</label>
                    <validation-provider name="Ano" rules="required|min:4" v-slot="{ errors, classes }">
                      <b-form-input 
                      type="tel"  
                      v-model="dadosForm.anuncio.anoBike" 
                       v-mask="['####']"
                      :class="classes">
                      </b-form-input>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                    <!-- <div class="text-muted">
                <small>Se tiver mais de uma cor, informe a cor predominante.</small>
                    </div>-->
                  </div>
                </div>
              </div>
              <div class="text-right" v-if="isNextStepClosed">
                <button
                  :disabled="loadingContinuarEtapa"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>

          <template v-slot:step3="{ openNextStep, isNextStepClosed }">
            <div class="alert mt-3">
              <div>
                <i class="fa fa-info-circle text-info mr-1"></i>
                <span
                  class="font-weight-bold"
                >Certifique-se de não anunciar répicas e falsificações.</span>
              </div>
              <p>
                <small>
                  O comércio de réplicas e falsificações é crime. Quem
                  oferecê-las será responsabilizado legalmente.
                </small>
              </p>
              <div class="text-right" v-if="isNextStepClosed">
                <button class="btn btn-info" @click="openNextStep">Entendido</button>
              </div>
            </div>
          </template>

          <template v-slot:step4="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-3">
              <h5 class="font-weight-bold">2. Ficha Técnica</h5>
              <p>
                <small>
                  Preencha os dados para ter um posicionamento melhor nas buscas
                  e fazer com que seus compradores tenham as informações
                  necessárias para comprar de você.
                </small>
              </p>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Câmbio dianteiro:</label>
                    <!-- <validation-provider
                      name="câmbio dianteiro"
                      rules="required"
                      v-slot="{ errors, classes }"
                    > -->
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="
                          getOptionsCambio(config.VELOCIDADES_CAMBIO_DIANTEIRO)
                        "                        
                        v-model="dadosForm.anuncio.cambioDianteiro"
                      ></v-select>
                      <!-- <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider> -->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Câmbio traseiro:</label>
                    <!-- <validation-provider
                      name="câmbio traseiro"
                      rules="required"
                      v-slot="{ errors, classes }"
                    > -->
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="
                          getOptionsCambio(config.VELOCIDADES_CAMBIO_TRASEIRO)
                        "                        
                        v-model="dadosForm.anuncio.cambioTraseiro"
                      ></v-select>
                      <!-- <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider> -->
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Tamanho da roda/aro:</label>
                    <validation-provider
                      name="tamanho da roda/aro"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.tiposAro)"
                        :class="classes"
                        v-model="dadosForm.anuncio.idTipoAro"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                 <div class="col-lg-6">
                  <div class="form-group">
                    <label>Tipo do garfo:</label>
                    <validation-provider
                      name="tipo do garfo"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.tiposGarfo)"
                        :class="classes"
                        v-model="dadosForm.anuncio.idTipoGarfo"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label style="height:24px;" >Tipo do quadro:</label>
                    <validation-provider
                      name="tipo do quadro"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.tiposQuadro)"
                        :class="classes"
                        v-model="dadosForm.anuncio.idTipoQuadro"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Tamanho do quadro: <button class="btn btn-sm py-0" v-b-modal.modal-tamanho-quadro><i class="fa fa-question-circle text-info" ></i></button></label>
                    <validation-provider
                      name="tamanho do quadro"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="config.TAMANHOS_QUADRO"
                        :class="classes"
                        v-model="dadosForm.anuncio.tamanhoQuadro"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
               
              </div>

              <div class="text-right" v-if="isNextStepClosed">
                <button
                  :disabled="loadingContinuarEtapa"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>

          <template v-slot:step5="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-3">
              <h5 class="font-weight-bold">Freio e Suspensão</h5>

              <div class="row">
                <div class="col-lg-5">
                  <div class="form-group">
                    <label>Tipo de freio:</label>
                    <validation-provider
                      name="tipo de freio"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.tiposFreio)"
                        v-model="dadosForm.anuncio.idTipoFreio"
                        :class="classes"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="form-group">
                    <label>Detalhes do freio:</label>
                    <b-form-input type="text" v-model="dadosForm.anuncio.detalhesFreio"></b-form-input>
                  </div>
                </div>
                <div class="col-lg-5">
                  <div class="form-group">
                    <label>Tipo da suspensão:</label>
                    <validation-provider
                      name="tipo de suspensão"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.tiposSuspensao)"
                        :class="classes"
                        v-model="dadosForm.anuncio.idTipoSuspensao"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="form-group">
                    <label>Detalhes da suspenção:</label>
                    <b-form-input type="text" v-model="dadosForm.anuncio.detalhesSuspensao"></b-form-input>
                  </div>
                </div>
              </div>

              <div class="text-right" v-if="isNextStepClosed">
                <button
                  :disabled="loadingContinuarEtapa"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>

          <template v-slot:step6="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-3">
              <h5 class="font-weight-bold">Informações complementares</h5>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Roda:</label>
                    <b-form-input type="text" v-model="dadosForm.anuncio.detalhesRoda"></b-form-input>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Pneu:</label>
                    <b-form-input type="text" v-model="dadosForm.anuncio.detalhesPneu"></b-form-input>
                  </div>
                </div>
              </div>

              <label>Outros detalhes da bike:</label>

              <textarea class="form-control" v-model="dadosForm.anuncio.outrasInformacoes"></textarea>

              <div class="text-right" v-if="isNextStepClosed">
                <button
                  :disabled="loadingContinuarEtapa"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>

          <template v-slot:step7="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-5">
              <h5 class="font-weight-bold">3. Preço de venda</h5>
              <div class="row">
                <div class="col-lg-6">
                  <validation-provider
                    name="preço de venda"
                    rules="required|min_value:1"
                    v-slot="{ errors, classes }"
                  >
                    <div class="input-group mt-2 mb-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <money
                        v-model="dadosForm.anuncio.precoVenda"
                        v-bind="{
                          decimal: ',',
                          thousands: '.',
                          prefix: '',
                          suffix: '',
                          precision: 2,
                        }"
                        :class="['form-control', classes]"
                      ></money>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Possui nota fiscal?</label>
                    <validation-provider
                      name="nota fiscal"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <b-form-radio-group
                        name="nota-fiscal"
                        v-model="dadosForm.anuncio.possuiNotaFiscal"
                        :class="classes"
                      >
                        <b-form-radio :value="true" class="mr-5">Sim</b-form-radio>
                        <b-form-radio :value="false">Não</b-form-radio>
                      </b-form-radio-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="text-right" v-if="isNextStepClosed">
                <button
                  :disabled="loadingContinuarEtapa"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>

          <template v-slot:step8="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-5">
              <h5 class="font-weight-bold">4. Fotos</h5>

              <VueFileAgent
                :multiple="true"
                :deletable="true"
                :sortable="false"
                :accept="config.FOTOS_ANUNCIO_FILE_TYPES"
                :maxSize="'6MB'"
                :maxFiles="12"
                :helpText="'Arraste suas fotos ou clique aqui...'"
                :errorText="{
                  type: 'Arquivo inválido. Apenas imagens são pertimidas.',
                  size: 'O arquivo de imagem não deve exceder 6MB de tamanho.',
                }"
                :uploadUrl="`${config.API_URL}/anuncio/uploadFoto?idAnuncio=${dadosForm.anuncio.idAnuncio}`"
                :uploadHeaders="requestHeaders"
                v-model="fotos"
                @select="onSelectFoto"
                @upload="onUpload"
                @delete="onDeleteFoto"
              ></VueFileAgent>

              <div class="alert alert-info mt-3">
                <i class="fa fa-info-circle text-info mr-1"></i>
                <small>
                  <b>Dica:</b> Prefira colocar como fotos de fundo branco
                  criadas com algum editor de imagem. Evite adicionar bordas,
                  logotipos ou marcas d'agua.
                </small>
              </div>
              <div class="text-right" v-if="isNextStepClosed">
                <button
                  :disabled="loadingContinuarEtapa || uploadingFoto"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>

          <!-- <template v-slot:step8="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-5">
              <h5 class="font-weight-bold">5. Registre sua bike</h5>
              <p>
                <button class="btn btn-link" v-b-modal.modal-video-registrar-bike>
                  <i class="fa fa-play-circle"></i> Assista ao vídeo de como registrar sua bike corretamente.
                </button>
                <br />
                <small>Uma bike registrada tem maior avaliação nos resultados e aceitação por parte dos compradores.</small>
              </p>

              <label class="font-weight-bold">Número de série</label>
              <div class="row small-gutters">
                <div
                  v-for="(item, index) in blocosRegistro"
                  :key="'bloco-registro'+index"
                  class="col-lg-4 mb-2"
                >
                  <input
                    type="text"
                    class="form-control"
                    style="text-transform: uppercase;"
                    v-model="blocosRegistro[index]"
                  />
                  <div class="text-right text-lg-left">
                    <button
                      class="btn btn-sm btn-link text-danger"
                      @click="removerBlocoRegistro(index)"
                      v-if="index > 0"
                    >
                      <small>Remover bloco</small>
                    </button>
                  </div>
                </div>
                <div class="col-lg-4">
                  <button
                    class="btn btn-sm btn-yellow"
                    @click="adicionarBlocoRegistro"
                    v-if="blocosRegistro.length < 5"
                  >Adicionar bloco</button>
                </div>
              </div>

              <div class="text-right mt-3" v-if="isNextStepClosed">
                <hr />
                <button class="btn btn-link text-danger mr-3" @click="openNextStep">
                  <small>Não quero registrar</small>
                </button>
                <button class="btn btn-primary" @click="openNextStep">Continuar</button>
              </div>
            </b-card>
          </template>-->

          <template v-slot:step9="{ openNextStep, isNextStepClosed }">
            <b-card class="shadow mt-5">
              <h5 class="font-weight-bold">5. Confirmação de dados para contato</h5>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>E-mail:</label>
                    <validation-provider
                      name="e-mail"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :class="classes"
                        v-model="dadosForm.anuncio.emailContato"
                      />
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Tipo de entrega:</label>
                    <validation-provider
                      name="tipo de entrega"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        :clearable="false"
                        :searchable="false"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.tiposEntrega)"
                        :class="classes"
                        v-model="dadosForm.anuncio.idTipoEntrega"
                      ></v-select>
                      <span class="invalid-feedback">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Estado:</label>
                    <validation-provider
                      name="estado"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        label="text"
                        :clearable="false"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.uf)"
                        v-model="dadosForm.anuncio.idUf"
                        @input="popularCidades"
                        :classes="classes"
                      ></v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Cidade:</label>
                    <validation-provider
                      name="cidade"
                      rules="required"
                      v-slot="{ errors, classes }"
                    >
                      <v-select
                        placeholder="Selecione..."
                        label="text"
                        :clearable="false"
                        :reduce="(option) => option.value"
                        :options="helper.getOptions(dadosForm.cidades)"
                        v-model="dadosForm.anuncio.idCidade"
                        :classes="classes"
                        :disabled="!dadosForm.anuncio.idUf"
                      ></v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    <div v-if="loadingCidades">Carregando...</div>
                  </div>
                </div>
              </div>
              <validation-provider
                name="celular"
                rules="required|min:14"
                v-slot="{ errors, classes }"
              >
                <div class="row">
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label>Celular com DDD:</label>

                      <input
                        type="tel"
                        placeholder="(00) 00000-0000"
                        class="form-control"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        :class="classes"
                        v-model="dadosForm.anuncio.telefoneContato"
                      />
                      <span class="invalid-feedback">{{ errors[0] }}</span>

                      <div
                        v-if="dadosForm.anuncio.telefoneContato && errors.length == 0 && celularVerificado()"
                        class="text-success"
                      >
                        <small>
                          <i class="fas fa-check mr-1"></i> Número verificado
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <div
                      v-if="dadosForm.anuncio.telefoneContato && errors.length == 0 && !celularVerificado()"
                    >
                      <i class="fa fa-exclamation-triangle text-warning mr-1"></i>
                      <small>ATENÇÂO: Este celular precisa ser verificado.</small>
                      <button
                        class="btn btn-primary"
                        v-b-modal.modal-verificar-celular
                      >Clique aqui para verificar</button>
                    </div>
                  </div>
                </div>
              </validation-provider>

              <div class="text-right" v-if="isNextStepClosed && celularVerificado()">
                <button
                  :disabled="loadingContinuarEtapa"
                  class="mt-3 btn btn-primary"
                  @click="onClickContinuar(openNextStep)"
                >
                  <span v-if="loadingContinuarEtapa">Carregando...</span>
                  <span v-else>Continuar</span>
                </button>
              </div>
            </b-card>
          </template>
          <template v-slot:step10>
            <button
              class="mt-5 btn btn-primary btn-lg btn-block"
              @click="onClickSalvarAnuncio"
              :disabled="loadingSalvar"
            >
              <span v-if="loadingSalvar">Salvando...</span>
              <span
                v-else-if="dadosForm.anuncio.status == statusAnuncio.STATUS_ANUNCIO_ATIVO || dadosForm.anuncio.status == statusAnuncio.STATUS_ANUNCIO_DESATIVADO"
              >Salvar anúncio</span>
              <span v-else>Salvar anúncio e continuar</span>
            </button>
          </template>
        </RevealStepForm>
      </ValidationObserver>
    </div>
    <!-- <b-modal
      id="modal-video-registrar-bike"
      hide-footer
      size="lg"
      title="Como registrar sua bike corretamente"
    >
      <div class="embed-responsive embed-responsive-16by9">
        <iframe
          class="embed-responsive-item"
          src="https://www.youtube.com/embed/lB7mWv873AA"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </b-modal>-->
    <ModalVerificarCelular :celular="obterCelular()" @verificado="onVerificado"></ModalVerificarCelular>
    <ModalTamanhoQuadro/>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import { Money } from "v-money";

import RevealStepForm from "../../../helpers/RevealStepForm";
import VueSelectOtherOption from "../../../helpers/VueSelectOtherOption";
import smoothScroll from "../../../helpers/smoothScroll";
import ModalVerificarCelular from "../../../components/Dashboard/ModalVerificarCelular";
import ModalTamanhoQuadro from "../../../components/ModalTamanhoQuadro";

import captureError from "../../../helpers/captureError";
import config from "../../../config";
import auth from "../../../core/auth";
import statusAnuncio from "../../../core/statusAnuncio";
import helper from "../../../helpers/helper";
import tempoUsoBike from "../../../core/tempoUsoBike";

export default {
  components: {
    RevealStepForm,
    Money,
    VueSelectOtherOption,
    ModalVerificarCelular,
    ModalTamanhoQuadro
  },
  data() {
    return {
      config,
      helper,
      statusAnuncio,
      tempoUsoBike,

      loadingGeral: false,
      dadosForm: {
        anuncio: {
          telefoneContato: "",
          condicaoBike: undefined,
          anoBike:0
        },
        marca: {},
        modelo: {},
        cidades: {},
        uf: {}
      },
      stepCount: 11,
      openUntilStep: undefined,
      loadingContinuarEtapa: false,

      forceOtherOptionModelo: false,
      loadingModelos: false,
      loadingCidades: false,

      ultimoCelularVerificado: undefined,

      loadingSalvar: false,

      uploadingFoto: false,
      fotos: [],
      blocosRegistro: [""],
      requestHeaders: {},

      exibirTempoUso: false
    };
  },
  async created() {
    var idAnuncio = this.$route.params.idAnuncio;

    await this.popularDadosForm(idAnuncio);

    var userInfo = auth.getUserInfo();
    this.requestHeaders = { Authorization: "Bearer " + userInfo.token };
  },
  // watch: {
  //   'dadosForm.anuncio.telefoneContato': {
  //     deep: false,
  //     handler(newValue, oldValue){
  //       if(newValue != oldValue){
  //         console.log("Celular changed");

  //         var novoNumero = helper.getOnlyNumbers(newValue);
  //         var numeroValidado = helper.getOnlyNumbers(this.ultimoCelularVerificado);
  //         if(novoNumero == numeroValidado){
  //           this.celularVerificado = true;
  //         }
  //         else
  //         {
  //           this.celularVerificado = false;
  //         }
  //       }
  //     }
  //   }
  // },
  methods: {
    celularVerificado() {
      if (
        !this.ultimoCelularVerificado ||
        !this.dadosForm.anuncio.telefoneContato
      ) {
        return false;
      }

      var numeroTelefone = helper.getOnlyNumbers(
        this.dadosForm.anuncio.telefoneContato
      );
      var numeroUltimoCelularVerificado = helper.getOnlyNumbers(
        this.ultimoCelularVerificado
      );

      var verificado = numeroTelefone == numeroUltimoCelularVerificado;
      return verificado;
    },
    // verificarSeAlterouCelularValidado() {
    //   if (!this.ultimoCelularVerificado) {
    //     return;
    //   }

    //   var novoNumero = helper.getOnlyNumbers(
    //     this.dadosForm.anuncio.telefoneContato
    //   );
    //   var numeroValidado = helper.getOnlyNumbers(this.ultimoCelularVerificado);
    //   if (novoNumero == numeroValidado) {
    //     this.celularVerificado = true;
    //   } else {
    //     this.celularVerificado = false;
    //   }
    //   //console.log("cel validado:", this.celularVerificado);
    // },
    getOptionsCambio(velocidades) {
      var options = [{ value: undefined, text: "Não tem" }];
      velocidades = velocidades || 0;

      for (let index = 0; index < velocidades; index++) {
        var velocidade = index + 1;

        var text = `${velocidade} ${
          velocidade > 1 ? "velocidades" : "velocidade"
        }`;
        var opt = { value: velocidade, text: text };
        options.push(opt);
      }

      return options;
    },

    adicionarBlocoRegistro() {
      this.blocosRegistro.push("");
    },
    removerBlocoRegistro(index) {
      this.blocosRegistro.splice(index, 1);
    },
    async popularDadosForm(idAnuncio) {
      try {
        this.loadingGeral = true;

        var response = await axios.get(
          `${config.API_URL}/anuncio/dadosForm?idAnuncio=${
            idAnuncio && idAnuncio !== "undefined" ? idAnuncio : ""
          }`
        );
        this.dadosForm = response.data;
        //Dados que não podem ser undefined devido aos v-model
        this.dadosForm.anuncio = response.data?.anuncio || {};

        this.dadosForm.registrosDisponiveis =
          response.data?.registrosDisponiveis || [];

        this.dadosForm.anuncio.precoVenda =
          response.data?.anuncio?.precoVenda || 0;

        this.dadosForm.anuncio.condicaoBike =
          response.data?.anuncio.condicaoBike;
        this.exibirTempoUso =
          this.dadosForm.anuncio.condicaoBike == config.CONDICAO_BIKE_USADA;

        this.dadosForm.anuncio.tempoUsoMeses = response.data?.anuncio.tempoUsoMeses?.toString();

        this.$set(this.dadosForm.anuncio,"telefoneContato", response.data?.anuncio.telefoneContato || "")
        // this.dadosForm.anuncio.telefoneContato =
        //   response.data?.anuncio.telefoneContato || "";

        if (response.data?.anuncio?.telefoneValidado) {
          this.ultimoCelularVerificado = this.dadosForm.anuncio.telefoneContato;
        } else {
          this.ultimoCelularVerificado = undefined;
        }

        if (this.dadosForm.anuncio.idRegistro) {
          var registro = this.dadosForm.registrosDisponiveis.find(
            item => item.id == this.dadosForm.anuncio.idRegistro
          );
          this.aplicarDadosRegistroSelecionado(registro);
        }

        //Populando fotos
        this.popularFotos();

        this.abrirEtapasFormulario();

        this.loadingGeral = false;
      } catch (e) {
        captureError(e);
        //console.log(e);
        this.loadingGeral = false;

        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            "Não foi possível carregar os dados. Tente novamente mais tarde ou contate o suporte."
        });

        this.$router.replace("/dashboard/meus-anuncios");
      }
    },
    popularFotos() {
      this.fotos = [];

      var fotosObj = this.dadosForm.anuncio.fotos;
      for (var fotoId in fotosObj) {
        var fotoUrl = fotosObj[fotoId];

        this.fotos.push({
          name: fotoId,
          size: 100,
          type: "image/jpeg",
          url: fotoUrl
        });
      }
    },
    async popularModelos() {
      try {
        //Limpa o campo modelo
        this.dadosForm.anuncio.modelo = undefined;

        var marca = this.dadosForm.anuncio.marca;
        if (!marca) {
          return;
        }

        this.loadingModelos = true;

        var response = await axios.get(
          `${config.API_URL}/modelo/porMarca?idMarca=${marca || ""}`
        );
        this.dadosForm.modelos = response.data;

        this.loadingModelos = false;
      } catch (e) {
        captureError(e);
        this.loadingModelos = false;

        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            "Não foi possível carregar os modelos. Tente novamente mais tarde ou contate o suporte."
        });
      }
    },
    async popularCidades() {
      try {
        //Limpa o campo cidade
        this.dadosForm.anuncio.idCidade = undefined;

        var idUf = this.dadosForm.anuncio.idUf;
        if (!idUf) {
          return;
        }

        this.loadingCidades = true;

        var response = await axios.get(`${config.API_URL}/uf/${idUf}/cidades`);
        this.dadosForm.cidades = response.data;

        this.loadingCidades = false;
      } catch (e) {
        captureError(e);
        this.loadingCidades = false;

        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            "Não foi possível carregar as cidades. Tente novamente mais tarde ou contate o suporte."
        });
      }
    },

    async onClickContinuar(openNextStepFn, pularSalvar) {
      var validado = await this.validarEtapas();

      if (!validado) {
        return;
      }

      if (pularSalvar) {
        if (openNextStepFn) {
          openNextStepFn();
        }
        return;
      }

      this.loadingContinuarEtapa = true;

      var result = await this.salvarAnuncio();

      this.loadingContinuarEtapa = false;

      if (result && openNextStepFn) {
        openNextStepFn();
      }

      if (!this.$route.params.idAnuncio) {
        history.pushState(
          {},
          null,
          this.$route.path + "/" + this.dadosForm.anuncio.idAnuncio
        );
        //this.$router.replace(`/dashboard/anuncio/${this.dadosForm.anuncio.idAnuncio}`);
      }
    },
    async salvarAnuncio() {
      try {
        var response = await axios.post(
          `${config.API_URL}/anuncio`,
          this.dadosForm.anuncio
        );

        //Após criar o anúncio, retorna informações no cliente para o passo 5
        this.dadosForm.anuncio.idAnuncio = response?.data?.idAnuncio;
        this.dadosForm.anuncio.emailContato = response?.data?.emailContato;
        this.dadosForm.anuncio.idCidade = response?.data?.idCidade;
        this.dadosForm.anuncio.idUf = response?.data?.idUf;

        this.dadosForm.anuncio.telefoneContato = response.data?.telefoneContato || "";
        if (response.data?.telefoneValidado) {
          this.ultimoCelularVerificado = this.dadosForm.anuncio.telefoneContato;
        } else {
          this.ultimoCelularVerificado = undefined;
        }

      } catch (e) {
        captureError(e);
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            "Não foi possível salvar o anúncio. Tente novamente mais tarde ou contate o suporte."
        });

        return false;
      }
      return true;
    },
    async validarEtapas() {
      //Valida dados do formulário
      var formEtapasValidado = await this.$refs.formEtapas.validate();

      if (!formEtapasValidado) {
        await Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Por favor preencha os campos obrigatórios."
        });

        //Focando no primeiro campo com erro
        var errorField = this.$el.querySelector(".is-invalid");
        if (errorField) {
          smoothScroll.smoothScrollYToElement(errorField, 700, -100);
        }

        return false;
      }

      return true;
    },

    abrirEtapasFormulario() {
      //Verifica os dados preenchidos do anuncio para saber em qual etapa deve abrir para continuar
      if (
        this.dadosForm.anuncio.idRegistro ||
        this.dadosForm.registrosDisponiveis.length == 0
      ) {
        this.openUntilStep = 1;
      }

      if (this.dadosForm.anuncio.condicaoBike) {
        this.openUntilStep = 2;
      }

      if (
        this.dadosForm.anuncio.marca &&
        this.dadosForm.anuncio.modelo &&
        this.dadosForm.anuncio.idTipoBike &&
        this.dadosForm.anuncio.idTipoRecomendacao &&
        this.dadosForm.anuncio.cor
      ) {
        this.openUntilStep = 4;
      }

      if (
        this.dadosForm.anuncio.cambioDianteiro &&
        this.dadosForm.anuncio.cambioTraseiro &&
        this.dadosForm.anuncio.idTipoAro &&
        this.dadosForm.anuncio.idTipoQuadro &&
        this.dadosForm.anuncio.idTipoGarfo
      ) {
        this.openUntilStep = 5;
      }

      if (
        this.dadosForm.anuncio.idTipoFreio &&
        this.dadosForm.anuncio.idTipoSuspensao
      ) {
        this.openUntilStep = 6;
      }

      if (
        this.dadosForm.anuncio.detalhesPneu ||
        this.dadosForm.anuncio.detalhesRoda ||
        this.dadosForm.anuncio.outrasInformacoes
      ) {
        this.openUntilStep = 7;
      }

      if (
        this.dadosForm.anuncio.precoVenda &&
        this.dadosForm.anuncio.possuiNotaFiscal !== undefined
      ) {
        this.openUntilStep = 8;
      }

      if (this.fotos.length > 0) {
        this.openUntilStep = 9;
      }

      if (
        this.dadosForm.anuncio.emailContato &&
        this.dadosForm.anuncio.telefoneContato &&
        this.dadosForm.anuncio.idTipoEntrega &&
        this.celularVerificado()
      ) {
        this.openUntilStep = 10;
      }
    },
    onDeleteFoto(args) {
      var fotoId = args.name();
      if (!this.dadosForm.anuncio.fotosDeletadas) {
        this.dadosForm.anuncio.fotosDeletadas = [];
      }
      this.dadosForm.anuncio.fotosDeletadas.push(fotoId);

      //Abrindo formulário apenas até o passo da foto para exibir o botão continuar para salvar
      this.openUntilStep = 8;
    },
    onUpload() {
      //Abrindo formulário apenas até o passo da foto para exibir o botão continuar para salvar
      this.openUntilStep = 8;
      this.uploadingFoto = false;
    },
    onSelectFoto(){
      this.uploadingFoto = true;
    },
    onVerificado(verificado) {
      if (verificado) {
        this.ultimoCelularVerificado = this.dadosForm.anuncio.telefoneContato;
      }
    },
    async onClickSalvarAnuncio() {
      var validado = await this.validarEtapas();

      if (!validado) {
        return;
      }

      if (!this.celularVerificado()) {
        await Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Por favor verifique o celular informado."
        });

        return false;
      }

      this.loadingSalvar = true;

      var result = await this.salvarAnuncio();

      this.loadingSalvar = false;

      if (result) {
        await Swal.fire({
          icon: "success",
          title: "Salvo com sucesso"
        });

        if (
          this.dadosForm.anuncio.status == statusAnuncio.STATUS_ANUNCIO_ATIVO ||
          this.dadosForm.anuncio.status ==
            statusAnuncio.STATUS_ANUNCIO_DESATIVADO
        ) {
          this.$router.replace("/dashboard/meus-anuncios");
        } else {
          this.$router.push(
            "/dashboard/escolher-plano/" + this.dadosForm.anuncio.idAnuncio
          );
        }
      }
    },
    onClickBikeExistente(openNextStep, registro) {
      //Aplicando dados da bike selecionada
      this.aplicarDadosRegistroSelecionado(registro);

      openNextStep();
    },
    onClickOutraBike(openNextStep) {
      //Limpando dados
      this.aplicarDadosRegistroSelecionado(undefined);

      openNextStep();
    },
    aplicarDadosRegistroSelecionado(registro) {
      if (!registro) {
        registro = {};
      }
      this.dadosForm.anuncio.idRegistro = registro.id;
      this.dadosForm.anuncio.marca = registro.idMarca;
      this.dadosForm.anuncio.outraMarca = false;
      this.dadosForm.anuncio.modelo = registro.modelo;
      this.dadosForm.anuncio.outroModelo = !!registro.modelo;
      this.dadosForm.anuncio.idTipoBike = registro.idTipoBike;
      this.dadosForm.anuncio.cor = registro.cor;
      this.dadosForm.anuncio.anoBike=registro.anoBike;
      this.dadosForm.anuncio.cambioDianteiro = registro.cambioDianteiro;
      this.dadosForm.anuncio.cambioTraseiro = registro.cambioTraseiro;
      this.dadosForm.anuncio.idTipoAro = registro.idTipoAro;
      this.dadosForm.anuncio.idTipoQuadro = registro.idTipoQuadro;
      this.dadosForm.anuncio.idTipoGarfo = registro.idTipoGarfo;
      this.dadosForm.anuncio.idTipoFreio = registro.idTipoFreio;
      this.dadosForm.anuncio.idTipoSuspensao = registro.idTipoSuspensao;
      this.dadosForm.anuncio.outrasInformacoes = registro.observacao;
    },
    onChangeCondicaoBike() {
      //console.log("on change condição");
      this.dadosForm.anuncio.tempoUsoMeses = undefined;
      this.exibirTempoUso =
        this.dadosForm.anuncio.condicaoBike == config.CONDICAO_BIKE_USADA;
    },
    obterCelular(){
      return this.dadosForm?.anuncio?.telefoneContato;
    }
  }
};
</script>

<style>
/* 
 -----------------------------------------------------------
Ajustando alguns elementos do componente file upload */

.anuncio-container .grid-block-wrapper .grid-block {
  min-width: 200px;
}

@media (max-width: 768px) {
  .anuncio-container .grid-block-wrapper .grid-block {
    min-width: 100px !important;
  }
}

.anuncio-container .file-preview .file-name {
  display: none;
}

.anuncio-container .file-preview .image-dimension {
  display: none;
}

.anuncio-container .file-preview .file-ext {
  display: none;
}
.anuncio-container .file-preview .file-size {
  display: none;
}

.anuncio-container .file-preview .file-delete {
  color: #ff5a40;
  border-radius: 50%;
  width: 28px;
  font-size: 18px;
  background-color: white;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
}

.anuncio-container .file-preview .help-text {
  font-size: 14px;
  line-height: 16px;
}

.anuncio-container
  .vue-file-agent
  .file-category-video-playable
  .file-preview:after,
.vue-file-agent .file-preview-wrapper-image .file-preview:after {
  box-shadow: none;
}

.anuncio-container
  .vue-file-agent
  .file-category-video-playable
  .file-preview:before,
.vue-file-agent .file-preview-wrapper-image .file-preview:before {
  box-shadow: inset 0 40px 20px -25px rgba(0, 0, 0, 0.16);
}

.vue-file-agent .file-preview-wrapper.file-preview-new:before {
  background: transparent;
}
/* ----------------------------------------------------------- */
</style>
<style lang="less" scoped>
@import "../../../styles/variaveis";

.anuncio-container {
  // background-color:red;
  max-width: 768px;
}

label:not(.custom-control-label) {
  // margin-top: 0.75rem;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.barra-progresso {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: #f9f9f9;
  /* color: white; */
  width: 100%;
  text-align: center;
  padding: 4px;
  font-size: 0.9rem;
}

.marca {
  color: #858585;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
}

.modelo {
  color: @default-text-color;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
}

.icone-novo-anuncio{
  height: 160px;
}



@media (max-width: 576px) {
 .icone-novo-anuncio{
  height: 120px;
}
}
</style>
